export const PhysicalTransportConst = {
  displayedColumns: [
    'id',
    'name',
    'pol_code',
    'pod_code',
    'expected_date',
    'actual_date',
    'live_status_name',
    'action',
  ],
  Journey: 'journeys',
  Search: 'search',
  Report: 'report',
  ReportMaster: 'report-master'
};
